import React from 'react'
import {connect} from 'react-redux'
import Titulo from '../comum/Titulo';
import {getAdminEmpresa, getGestorEmpresa, getOperadorEmpresa, getGestorOperacoes, PERFIL_ADMIN} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import {alterouFiltro, alterouPagina} from '../../util/filtros';
import buscarPrestadores from '../../actions/prestador/buscarPrestadores';
import excluirPrestador from '../../actions/prestador/excluirPrestador';
import selecionarPrestador from '../../actions/prestador/selecionarPrestador';
import PaginacaoPrestador from './PaginacaoPrestador';
import BotoesPaginacaoPrestador from './BotoesPaginacaoPrestador';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import PainelFiltragem from './PainelFiltrosPrestador';
import Prestador from './Prestador';
import ModalCadastrarPrestador from './ModalCadastrarPrestador';
import {showSuccessMsg} from '../../util/messagesUtil';

const CabecalhoTabela = () => (
    <div className="vx-gp-table-header vx-gp-table-header--prestador d-none d-lg-grid">
        <div>Número</div>
        <div>Nome</div>
        <div>Responsável</div>
        <div>CPF/CNPJ</div>
        <div>Telefone</div>
        <div>Localidade</div>
        <div>Ações</div>
    </div>
);

const ModalConfirmacaoExclusao = ({excluir, prestador}) => (
    <div className="modal fade" id="modalConfirmacaoExclusaoPrestador" tabIndex="-1" role="dialog"
         aria-labelledby="modalConfirmacaoExclusaoPrestador" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
            <div className="modal-content vx-modal-content">
                <div className="vx-modal-header">
                    <div className="vx-modal-header-left">
                        <i className="material-icons" style={{ color: '#dc2626' }}>delete</i>
                        <span className="vx-modal-title">Excluir Prestador</span>
                    </div>
                    <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Fechar">
                        <i className="material-icons">close</i>
                    </button>
                </div>
                <div className="vx-modal-body" style={{ textAlign: 'center', padding: '24px' }}>
                    <p style={{ margin: 0, fontSize: '14px', color: '#444' }}>
                        Deseja excluir o prestador <strong>{prestador ? prestador.nome : ''}</strong>?
                    </p>
                </div>
                <div className="vx-modal-footer">
                    <button type="button" className="vx-btn-secondary" data-dismiss="modal">
                        Cancelar
                    </button>
                    <button type="button" className="vx-btn-danger" data-dismiss="modal"
                            onClick={() => excluir()}>
                        <i className="material-icons" style={{ fontSize: '16px' }}>delete</i>
                        Excluir
                    </button>
                </div>
            </div>
        </div>
    </div>
);

export class PainelGerenciarPrestadores extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            parametros: {
                nome: '',
                uf: ''
            }
        };
    }

    componentDidMount() {
        if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
            this.buscarPrestadores();
        }
    }

    componentDidUpdate(prevProps) {
        if (alterouPagina(this.props, prevProps) || alterouFiltro(this.props, prevProps) || this.props.empresaSelecionada !== prevProps.empresaSelecionada) {
            this.buscarPrestadores();
        }
    }

    buscarPrestadores() {
        this.props.buscarPrestadores(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
    }

    exibirPrestadores() {
        if (this.props.prestadores) {
            return this.props.prestadores.map(prestador => (
                <Prestador
                    key={prestador.id}
                    prestador={prestador}
                    idEmpresa={this.props.empresaSelecionada.id}
                />
            ));
        }
    }

    excluir() {
        this.props.excluirPrestador(this.props.prestadorSelecionado.id, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Prestador excluído com sucesso');
                this.buscarPrestadores();
            });
    }

    exibir() {
        if (this.props.prestadores && this.props.prestadores.length) {
            return (
                <CabecalhoRodapeTabela
                    OpcoesPaginacao={PaginacaoPrestador}
                    BotoesPaginacao={BotoesPaginacaoPrestador}
                >
                    <CabecalhoTabela />
                    {this.exibirPrestadores()}
                </CabecalhoRodapeTabela>
            );
        }
        return (
            <div className="vx-gp-empty">
                <i className="material-icons">assignment_ind</i>
                <span>Nenhum prestador encontrado para os parâmetros informados.</span>
            </div>
        );
    }

    render() {
        return (
            <Autorizacao
                perfisPermitidos={[
                    PERFIL_ADMIN,
                    getGestorEmpresa(this.props.empresaSelecionada.id),
                    getAdminEmpresa(this.props.empresaSelecionada.id),
                    getGestorOperacoes(this.props.empresaSelecionada.id),
                    getOperadorEmpresa(this.props.empresaSelecionada.id)
                ]}
                empresaSelecionada={this.props.empresaSelecionada}
            >
                <div className="container-padrao">
                    <Titulo texto="Prestadores Empresa" urlRetorno="/menu-itinerario" />
                    <PainelFiltragem />
                    <div className="vx-gp-toolbar">
                        <button
                            className="vx-btn-primary"
                            data-toggle="modal"
                            data-target="#modalCadastrarPrestador"
                            onClick={() => this.props.selecionarPrestador()}
                        >
                            <i className="material-icons" style={{ fontSize: '18px' }}>add</i>
                            Novo Prestador
                        </button>
                    </div>
                    {this.exibir()}
                </div>
                <ModalCadastrarPrestador
                    parametros={this.state.parametros}
                    buscarPrestadores={this.buscarPrestadores.bind(this)}
                />
                <ModalConfirmacaoExclusao
                    excluir={this.excluir.bind(this)}
                    prestador={this.props.prestadorSelecionado}
                />
            </Autorizacao>
        );
    }
}

export const mapStateToProps = state => ({
    prestadores: state.prestadores.prestadores,
    prestadorSelecionado: state.prestadores.prestadorSelecionado,
    empresaSelecionada: state.empresaSelecionada,
    paginaAtual: state.paginaAtualPrestador,
    registrosPorPagina: state.registrosPorPaginaPrestador,
    filtrosAdicionados: state.filtrosAdicionadosPrestador
});

export default connect(mapStateToProps, {
    buscarPrestadores,
    excluirPrestador,
    selecionarPrestador
})(PainelGerenciarPrestadores)
